import { registerComponent as e } from "../../utilities/utils.js";
import { IDSHeader as i } from "./header-element.js";
import { IDSHeaderAvatar as r } from "./avatar/header-avatar-element.js";
import { IDSHeaderItem as m } from "./item/header-item-element.js";
import { IDSHeaderNav as t } from "./navigation/navigation-element.js";
import { IDSHeaderNavItem as o } from "./navigation/item/navigation-item-element.js";
import { IDSHeaderMobileItem as a } from "./navigation/mobile-item/mobile-item-element.js";
import { IDSHeaderMobileMenu as s } from "./mobile-menu/header-mobile-menu-element.js";
import { IDSMobileMenuAvatar as n } from "../mobile/menu/avatar/mobile-menu-avatar-element.js";
import "../icons/chevron-bold/register.js";
import "../icons/user/register.js";
import "../icons/1177/register.js";
import "../icons/inera/register.js";
import "../icons/inera-legacy/register.js";
import "../grid/column/register.js";
import "../grid/row/register.js";
import "../grid/container/register.js";
import "../mobile/menu/register.js";
import "../notification/badge/register.js";
e("ids-header", i), e("ids-header-avatar", r), e("ids-header-item", m), e("ids-header-nav", t), e("ids-header-nav-item", o), e("ids-header-mobile-item", a), e("ids-header-mobile-menu", s), e("ids-mobile-menu-avatar", n);